// extracted by mini-css-extract-plugin
export default {"container":"DataSources_container__2URpC"};